import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { VENUES } from "../../../const/URL.const";
import { useAuthenticationContext } from "../../../yoello-lib/modules/auth/AuthenticationContext";

export function useCheckUserVerification() {
  const { verifyAuth, currentUser } = useAuthenticationContext();
  const history = useHistory();
  useEffect(() => {
    async function checkUserVerification() {
      const user = await verifyAuth();
      if (user) {
        history.push(VENUES+history.location.search);
      }
    }
    checkUserVerification();
    // eslint-disable-next-line
  }, [currentUser]);
}
